// export chroma.js here

export const coldPalette = [
  '#1698D9',
  '#00A44F',
  '#0077B3',
  '#31A368',
  '#607D8B',
  '#39BD78',
  '#673AB7',
  '#18F080',
  '#48B59F',
  '#4DFF75',
  '#455A64',
  '#0B735E',
  '#11A688',
  '#2196F3',
  '#3F51B5',
  '#03A9F4',
  '#CDDC39',
  '#8BC34A',
  '#00BCD4',
  '#9E9E9E',
  '#009688',
  '#4CAF50',
  '#FFEB3B',
  '#9CF233',
  '#607D8B',
  '#44CF57'
]

export const purplePalette = [
  '#004a8f',
  '#d40724',
  '#624095',
  '#c6005b',
  '#9e2383',
]
